"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUserTable = GetUserTable;
exports.PostUserEvent = PostUserEvent;
exports.PostUserAccountCreated = PostUserAccountCreated;
exports.PostAccountCreated = PostAccountCreated;
exports.PostNewAccountState = PostNewAccountState;
exports.PostLoginPasswordSuccess = PostLoginPasswordSuccess;
exports.PostLoginOTPSuccess = PostLoginOTPSuccess;
exports.PostLogin2FASuccess = PostLogin2FASuccess;
exports.PostLoginTokenSuccess = PostLoginTokenSuccess;
exports.PostSetPasswordSuccess = PostSetPasswordSuccess;
exports.PostLogout = PostLogout;
exports.PostLoginPasswordFail = PostLoginPasswordFail;
exports.PostLoginOTPFail = PostLoginOTPFail;
exports.PostLoginTokenFail = PostLoginTokenFail;
exports.PostSetPasswordFail = PostSetPasswordFail;
exports.PostOnboardingNav = PostOnboardingNav;
exports.PostOnboardingUpload = PostOnboardingUpload;
exports.PostOnboardingUploadDelete = PostOnboardingUploadDelete;
exports.PostOnboardingCompleted = PostOnboardingCompleted;
exports.PostDocusignStarted = PostDocusignStarted;
exports.PostDocusignCompleted = PostDocusignCompleted;
exports.PostDocusignNotCompleted = PostDocusignNotCompleted;
exports.PostKYCStart = PostKYCStart;
exports.PostKYCCancel = PostKYCCancel;
exports.PostKYCEnd = PostKYCEnd;
exports.PostIAVStart = PostIAVStart;
exports.PostIAVEnd = PostIAVEnd;
exports.PostIAVCancel = PostIAVCancel;
exports.PostMailDocuments = PostMailDocuments;
exports.PostMailInvite = PostMailInvite;
exports.PostUGMAInvite = PostUGMAInvite;
exports.PostResetPasswordEmail = PostResetPasswordEmail;
exports.PostCorporateEvent = PostCorporateEvent;
var response_1 = require("@ca/wrap-sdk/src/response");
var event_table_1 = require("@ca/event-table");
var events_1 = require("./events");
var aws_eventbridge_1 = require("@ca/wrap-sdk/src/aws-eventbridge");
var env_1 = require("@ca/wrap-sdk/src/env");
var CA_ACCOUNT = 'CA_ACCOUNT' in process.env
    ? process.env['CA_ACCOUNT']
    : "ACCOUNT_NUMBER";
function ParseUsernameIndex(username_index) {
    var user_re = /^(.*)_(\d{4})$/;
    var match = username_index.match(user_re);
    if (!match) {
        return (0, response_1.ErrorResponse)("No match");
    }
    return (0, response_1.SuccessResponse)({
        username: match[1],
        index: parseInt(match[2], 10),
    });
}
function GetUserTable() {
    return env_1.Stage.stage + "-UserEvents";
}
function PostUserEvent(creds, source, event, detail, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        var eb_event;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    eb_event = {
                        'detail-type': event,
                        source: (0, aws_eventbridge_1.GetSource)(source),
                        region: env_1.Region.region,
                        resources: [],
                        detail: detail,
                        time: new Date().toISOString(),
                        account: CA_ACCOUNT,
                    };
                    if (!table_name) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, event_table_1.EventToTableB)(creds, table_name, eb_event)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [4 /*yield*/, (0, event_table_1.EventToTable)(creds, eb_event)];
                case 3: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostUserAccountCreated(creds, source, username, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.USER_ACCOUNT_CREATED, { username: username }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostAccountCreated(creds, source, username, index, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.ACCOUNT_CREATED, { username: username, index: index }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostNewAccountState(creds, source, username, index, account_state, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.NEW_ACCOUNT_STATE, {
                        username: username,
                        index: index,
                        account_state: account_state
                    }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostLoginPasswordSuccess(creds, source, username, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.LOGIN_PASSWORD_SUCCESS, { username: username }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostLoginOTPSuccess(creds, source, username, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.LOGIN_OTP_SUCCESS, { username: username }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostLogin2FASuccess(creds, source, username, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.LOGIN_2FA_SUCCESS, { username: username }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostLoginTokenSuccess(creds, source, username, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.LOGIN_TOKEN_SUCCESS, { username: username }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostSetPasswordSuccess(creds, source, username, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.SET_PASSWORD_SUCCESS, { username: username }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostLogout(creds, source, username, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.LOGOUT, { username: username }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostLoginPasswordFail(creds, source, username, fail_count, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.LOGIN_PASSWORD_FAIL, { username: username, fail_count: fail_count }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostLoginOTPFail(creds, source, username, fail_count, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.LOGIN_OTP_FAIL, { username: username, fail_count: fail_count }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostLoginTokenFail(creds, source, username, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.LOGIN_TOKEN_FAIL, { username: username }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostSetPasswordFail(creds, source, username, reason, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.SET_PASSWORD_FAIL, { username: username, reason: reason }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostOnboardingNav(creds, source, username, index, path, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.ONBOARDING_NAV, { username: username, index: index, path: path }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostOnboardingUpload(creds, source, username, index, s3_path, file_name, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.ONBOARDING_UPLOAD, { username: username, index: index, s3_path: s3_path, file_name: file_name }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostOnboardingUploadDelete(creds, source, username, index, s3_path, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.ONBOARDING_UPLOAD_DELETE, { username: username, index: index, s3_path: s3_path }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostOnboardingCompleted(creds, source, username, index, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.ONBOARDING_COMPLETED, { username: username, index: index }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostDocusignStarted(creds, source, username, index, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.DOCUSIGN_STARTED, { username: username, index: index }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostDocusignCompleted(creds, source, username, index, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.DOCUSIGN_COMPLETED, { username: username, index: index }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostDocusignNotCompleted(creds, source, username, index, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.DOCUSIGN_NOT_COMPLETED, { username: username, index: index }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostKYCStart(creds, source, username, index, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.KYC_START, { username: username, index: index }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostKYCCancel(creds, source, username, index, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.KYC_CANCEL, { username: username, index: index }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostKYCEnd(creds, source, username, index, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.KYC_END, { username: username, index: index }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostIAVStart(creds, source, username, index, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.IAV_START, { username: username, index: index }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostIAVEnd(creds, source, username, index, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.IAV_END, { username: username, index: index }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostIAVCancel(creds, source, username, index, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.IAV_CANCEL, { username: username, index: index }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostMailDocuments(creds, source, username, index, filenames, message_id, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.EMAIL_DOCUMENTS, { username: username, index: index, filenames: filenames, message_id: message_id }, table_name || GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostMailInvite(creds, source, username, message_id) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.EMAIL_INVITE, { username: username, message_id: message_id }, GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostUGMAInvite(creds, source, username, index, invitee_name, invitee_email, queue_id, message_id) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.EMAIL_UGMA_INVITE, { username: username, index: index, invitee_name: invitee_name, invitee_email: invitee_email, queue_id: queue_id, message_id: message_id }, GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostResetPasswordEmail(creds, source, username, message_id) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.EMAIL_RESET_PASSWORD, { username: username, message_id: message_id }, GetUserTable())];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function PostCorporateEvent(creds, source, ticket_item, event_type, corp_event, table_name) {
    return __awaiter(this, void 0, void 0, function () {
        var p_resp, _a, username, index;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    p_resp = ParseUsernameIndex(ticket_item.username_index);
                    if (p_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, p_resp];
                    }
                    _a = p_resp.payload, username = _a.username, index = _a.index;
                    return [4 /*yield*/, PostUserEvent(creds, source, events_1.UserEvents.CORPORATE_EVENT, {
                            username: username,
                            index: index,
                            ticket_id: ticket_item.id,
                            event_type: event_type,
                            event: corp_event,
                        }, table_name)];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
//# sourceMappingURL=post-events.js.map